import { render, staticRenderFns } from "./InternalReviewCarousel.vue?vue&type=template&id=30a093b5"
import script from "./InternalReviewCarousel.vue?vue&type=script&lang=ts"
export * from "./InternalReviewCarousel.vue?vue&type=script&lang=ts"
import style0 from "./InternalReviewCarousel.vue?vue&type=style&index=0&id=30a093b5&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
